import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";

const useShopEmployees = (authToken) => {
  const { ezorder } = useContext(AuthContext);
  const [shopEmployees, setShopEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  let [hasLoaded, setHasLoaded] = useState(false);

  const getShopEmployees = async () => {
    try {
      setLoading(true);
      const res = await ezorder.get(`/users/shop`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setShopEmployees(res.data.shopEmployees);
      setHasLoaded(true);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getShopEmployees();
  }, []);

  return { shopEmployees, loading, hasLoaded };
};

export default useShopEmployees;
